import React from 'react';
import * as S from './order-summary-skeleton.style';

export const OrderSummaryClassicSkeleton: React.FC = () => {
  return (
    <S.SummaryContainer>
      {/* Título */}
      <S.TitleSkeleton />

      <S.SummaryBox>
        {/* Item principal */}
        <S.SummaryItem>
          <S.TextSkeleton width="60%" />
          <S.TextSkeleton width="30%" />
        </S.SummaryItem>

        {/* Order bumps (simulados) */}
        <S.SummaryItem style={{ marginTop: '8px' }}>
          <S.TextSkeleton width="55%" />
          <S.TextSkeleton width="25%" />
        </S.SummaryItem>

        <S.SummaryItem style={{ marginTop: '8px' }}>
          <S.TextSkeleton width="50%" />
          <S.TextSkeleton width="22%" />
        </S.SummaryItem>

        {/* Desconto */}
        <S.SummaryItem style={{ marginTop: '8px' }}>
          <S.TextSkeleton width="35%" />
          <S.TextSkeleton width="20%" />
        </S.SummaryItem>

        <S.Divider />

        {/* Total */}
        <S.TotalRow>
          <S.TextSkeleton width="30%" height="16px" />
          <S.TextSkeleton width="35%" height="16px" />
        </S.TotalRow>
      </S.SummaryBox>
    </S.SummaryContainer>
  );
};